export const LIST_NOTIFICATION = `homepage/list-notification`;
